import { render, staticRenderFns } from "./ChooseToStart.vue?vue&type=template&id=71d3a4c0&"
import script from "./ChooseToStart.vue?vue&type=script&lang=js&"
export * from "./ChooseToStart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports